/* eslint-disable no-case-declarations */
import React, { Component } from "react";
import cookie from "react-cookies";
import './style.scss';

class WragMenu extends Component {
    constructor(props) {
        super(props);

        let activeColor = 'light';
        let activeFont = 100;

        // For Colour Contrast
        if (cookie.load('colorContrast') != undefined && cookie.load('colorContrast') == 'dark') {
            document
                .body
                .classList
                .add('dark');
            activeColor = 'dark';
        }

        // For Font size increase/decrease
        if (cookie.load('modifiedFont') != undefined) {
            activeFont = cookie.load('modifiedFont');
            // (activeFont == 110 ? document.body.classList.add('enlarge-font'):'');
            // (activeFont == 90 ? document.body.classList.add('lessen-font'):'');
        }

        this.state={
            currentColorContrast: activeColor,
            activeFont: 100,
            increaseTimes: 0,
            decreaseTimes:0,
            contrast: true,
            whatWeLastDid: 1,
        }
    }
    componentDidMount = () => {
        if(this.state.currentColorContrast === 'dark'){
            $(".notification-bell-icon").attr("src","/images/homeIcons/notification-dark.png");
        } else {
            $(".notification-bell-icon").attr("src","/images/homeIcons/notification.png");
        }
    }
    setModifiedFont = (selectedFont) => {
        let newFontValue = 100;
        let {increaseTimes, decreaseTimes} = this.state;
        switch (selectedFont) {
            case 'increase':
                newFontValue = 110;
                if(this.state.whatWeLastDid === 0) {
                    let elements = document.getElementsByTagName("*");
                    for(let item = 0; item < elements.length; item++){
                        let style = window.getComputedStyle(elements[item], null).getPropertyValue('font-size');
                        let currentSize = parseFloat(style);
                        elements[item].style.fontSize = (currentSize + 4) + 'px';
                    }
                } else if(this.state.whatWeLastDid === 1) {
                    let elements = document.getElementsByTagName("*");
                    for(let item = 0; item < elements.length; item++){
                        let style = window.getComputedStyle(elements[item], null).getPropertyValue('font-size');
                        let currentSize = parseFloat(style);
                        elements[item].style.fontSize = (currentSize + 2) + 'px';
                    }
                }
                this.setState({whatWeLastDid : 2});
                break;
            case 'reset':
                newFontValue = 100;
                if(this.state.whatWeLastDid === 2) {
                    let elements = document.getElementsByTagName("*");
                    for(let item = 0; item < elements.length; item++){
                        let style = window.getComputedStyle(elements[item], null).getPropertyValue('font-size');
                        let currentSize = parseFloat(style);
                        elements[item].style.fontSize = (currentSize - 2) + 'px';
                    }
                }
                else if(this.state.whatWeLastDid === 0) {
                    let elements = document.getElementsByTagName("*");
                    for(let item = 0; item < elements.length; item++){
                        let style = window.getComputedStyle(elements[item], null).getPropertyValue('font-size');
                        let currentSize = parseFloat(style);
                        elements[item].style.fontSize = (currentSize + 2) + 'px';
                    }
                }
                this.setState({whatWeLastDid : 1});
                break;
            case 'decrease':
                newFontValue = 90;
                if(this.state.whatWeLastDid === 2) {
                    let elements = document.getElementsByTagName("*");
                    for(let item = 0; item < elements.length; item++){
                        let style = window.getComputedStyle(elements[item], null).getPropertyValue('font-size');
                        let currentSize = parseFloat(style);
                        elements[item].style.fontSize = (currentSize - 4) + 'px';
                    }
                }
                else if(this.state.whatWeLastDid === 1) {
                    let elements = document.getElementsByTagName("*");
                    for(let item = 0; item < elements.length; item++){
                        let style = window.getComputedStyle(elements[item], null).getPropertyValue('font-size');
                        let currentSize = parseFloat(style);
                        elements[item].style.fontSize = (currentSize - 2) + 'px';
                    }
                }
                this.setState({whatWeLastDid : 0});
                break;
            default:
                document.body.classList.remove('lessen-font');
                document.body.classList.remove('enlarge-font');
                break;
        }
        let cookieTime = 365 * 24 * 60 * 60;
        cookie.save('modifiedFont', newFontValue, {
            path: '/',
            maxAge: cookieTime,
            secure: true,
            sameSite: 'strict',
            httpOnly: true,
        });
        this.setState({activeFont: newFontValue});
    }

    colorContrast = (e) => {
        this.state.contrast ? this.setState({
            contrast: false,
        }) : this.setState({
            contrast: true,
        })

        let newCurrentContrast = (this.state.currentColorContrast == 'light'
            ? 'dark'
            : 'light');
        if(newCurrentContrast == 'light'){
            document.body.classList.remove('dark');
            $(".notification-bell-icon").attr("src","/images/homeIcons/notification.png");
            $(".bot-faq-pic").attr("src","/images/homeIcons/Infographic-1.png");
        }
        else {
            document.body.classList.add('dark');
            $(".notification-bell-icon").attr("src","/images/homeIcons/notification-dark.png");
            $(".bot-faq-pic").attr("src","/images/homeIcons/Infographic-2.png");
        }
        let cookieTime = 365 * 24 * 60 * 60;
        cookie.save('colorContrast', newCurrentContrast, {
            path: '/',
            maxAge: cookieTime,
            sameSite: 'strict',
        });
        this.setState({currentColorContrast: newCurrentContrast})

        let element = document.getElementById("bot-intro");
        element.classList.toggle("bot-intro-2");
    }

    render() {
        let {currentColorContrast, increaseTimes, decreaseTimes, whatWeLastDid} = this.state;
        let currentContrast = (currentColorContrast == 'light'
            ? 'High Contrast'
            : 'Normal Contrast');
        let colorContrast = 'contrast-color';
        if (cookie.load('colorContrast') != undefined && cookie.load('colorContrast') == 'dark') {
            colorContrast = 'contrast-color dark';
        }
        return (
            <ul className="websiteFont">
                <li className={whatWeLastDid === 0 ? 'active' : ''} >
                <a onClick={() => this.setModifiedFont('decrease')}
                        href='#' title="Decrease Font Size">-A</a>
                </li>
                <li className={whatWeLastDid === 1 ? 'active' : ''}>
                <a
                    onClick={() => this.setModifiedFont('reset')}
                    href='#' title="Decrease Font Size">A</a>
                </li>
                <li className={whatWeLastDid === 2 ? 'active' : ''} >
                    <a
                        onClick={() => this.setModifiedFont('increase')}
                        href='#'
                        title="Increase Font Size">+A</a>
                </li>
            </ul>
            // mediumText 
        );
    }
}

export default WragMenu;